import { useFooter } from '../../../hooks';
import { Footer as CommonFooter } from '@vfpt/common-fe-components';
import { mapFooterDataToProps } from './VodafoneFooterAdapter';

function VodafoneFooter() {
    const { footerData, loading } = useFooter({ name: 'Footer_pt' });

    if (loading || !footerData) {
        return null;
    }
    const footerProps = mapFooterDataToProps(footerData);

    return <CommonFooter {...footerProps} />;
}

export default VodafoneFooter;
